import React from "react";
import { StyleSheet, Text, View } from "react-native";
import MainNavigator from "./src/navigation/MainNavigator";
import AppLoading from "expo-app-loading";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import ReduxThunk from "redux-thunk";

import nftReducer from "./src/store/reducers/nfts";
import deviceReducer from "./src/store/reducers/device";
import userNftReducer from "./src/store/reducers/userNft";
import socketReducer from "./src/store/reducers/socket";
import {
  useFonts,
  JosefinSans_100Thin,
  JosefinSans_200ExtraLight,
  JosefinSans_300Light,
  JosefinSans_400Regular,
  JosefinSans_500Medium,
  JosefinSans_600SemiBold,
  JosefinSans_700Bold,
  JosefinSans_100Thin_Italic,
  JosefinSans_200ExtraLight_Italic,
  JosefinSans_300Light_Italic,
  JosefinSans_400Regular_Italic,
  JosefinSans_500Medium_Italic,
  JosefinSans_600SemiBold_Italic,
  JosefinSans_700Bold_Italic,
} from "@expo-google-fonts/josefin-sans";

// Import the functions you need from the SDKs you need
import firebase from "firebase";

import { getDatabase, ref, set } from "firebase/database";

import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC480yFDyUaL5a-Oca-V3q2Xzwzq4LkaDI",
  authDomain: "authentik-silo.firebaseapp.com",
  databaseURL: "https://authentik-silo-default-rtdb.firebaseio.com",
  // databaseURL: "http://localhost:9000/?ns=authentik-silo-default-rtdb",
  projectId: "authentik-silo",
  storageBucket: "authentik-silo.appspot.com",
  messagingSenderId: "532825356234",
  appId: "1:532825356234:web:f774ab408db7fb9a028133",
  measurementId: "G-LVYL1F3L5Y",
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app(); // if already initialized, use that one
}
// var database = firebase.database();
// const auth = firebase.auth();
// database.useEmulator("http://127.0.0.1", 9000);
// auth.useEmulator("http://127.0.0.1:9099");
const rootReducer = combineReducers({
  nfts: nftReducer,
  devices: deviceReducer,
  userNfts: userNftReducer,
  socket: socketReducer,
});

// IF devtool is enabled, it will trigger render twice and two socket io connection
// https://github.com/erikras/react-redux-universal-hot-example/issues/429
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancer = compose;

const store = createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(ReduxThunk))
);

export default function App() {
  let [fontsLoaded] = useFonts({
    JosefinSans_100Thin,
    JosefinSans_200ExtraLight,
    JosefinSans_300Light,
    JosefinSans_400Regular,
    JosefinSans_500Medium,
    JosefinSans_600SemiBold,
    JosefinSans_700Bold,
    JosefinSans_100Thin_Italic,
    JosefinSans_200ExtraLight_Italic,
    JosefinSans_300Light_Italic,
    JosefinSans_400Regular_Italic,
    JosefinSans_500Medium_Italic,
    JosefinSans_600SemiBold_Italic,
    JosefinSans_700Bold_Italic,
  });

  if (!fontsLoaded) {
    return <AppLoading />;
  } else {
    return (
      <Provider store={store}>
        <MainNavigator />
      </Provider>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  topSafeArea: {
    flex: 0,
    backgroundColor: "blue",
  },
});
